<template>
  <Card container-class="card shadow-sm" :title="$t('events.nps.list')">
    <template #cardToolbar>
      <Button v-if="nps.length > 0" btn-class="btn-md" type="new" btn-text="events.nps.new"  @click="ShowCreateNps"/>
    </template>
    <template #cardBody>
      <div class="row">
        <div v-if="nps.length > 0" class="row">
          <NpsCard v-for="element in nps" :nps="element" :key="element.id"/>
        </div> 
        <div v-if="nps.length == 0 && !getting">
          <Card class="card p-5 h-full">
            <div class=" text-center ">
              <div class="pt-8 ">
                <Img filename="empty.png" alt=""
                    class="mw-100 h-125px h-sm-175px" />
              </div>
              <h2 class="fs-2x fw-bolder mb-0">{{ $t('events.nps.noNpsCreated') }}</h2>
              <br>
              <br>
              <Button btn-class="btn-md" type="new" btn-text="events.nps.createNewOne" @click="ShowCreateNps"/>
              <br>
              <br>
              <br>
              <br>
            </div>
          </Card>
        </div>
      </div> 
    </template>
  </Card> 
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import NpsCard from "../../components/NpsCard.vue";
import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import abilities from "@/composables/abilities";
import Img from "@/components/Img.vue";

const route = useRoute()
const router = useRouter()

const store = useStore()

const nps = ref([])
const getting = ref(true)

watch(() => route.query.tab, (value) => {
    if(value == 'tab-nps') {
      loadNpsList()
    }
})

async function loadNpsList() {
  getting.value = true
  await store.dispatch('eventNps/getNpsList', route.params.id).then((res) => {
    nps.value = res?.data?.event_nps
  }).finally(() => {getting.value = false})
} 

const ShowCreateNps = () => {
  router.push({ name: 'events-nps-create', params: { id: route.params.id }, query: { tab: route.query.tab || 'tab-nps' } });
}

onMounted(() => {
  if(route.query.tab == 'tab-nps') loadNpsList()
})

</script>

<style scoped>
  .password-input {
    position: relative;
  }

  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  #eye-icon {
    font-size: 1.2em;
  }
</style>
